export default __webpack_public_path__ + "static/media/expand-more.4e83a029.svg";